
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'indexIndividualWeddingrings',
  props: {
    pageStr: {
      type: String,
      required: true,
    },
  },
  setup() {},
})
